import Keycloak from 'keycloak-js'

// export const keycloak = new Keycloak({
//  url: 'http://localhost:8080',
//  realm: 'procon-realm',
//  clientId: 'cx-react-app',
// })

export const keycloak = new Keycloak({
 url: 'https://auth.makotap.com',
 realm: 'procon-realm',
 clientId: 'mako-react-app',
})

export const initOptions = {
 onLoad: 'login-required',
 checkLoginIframe: false,
 pkceMethod: 'S256',
}

// export const initOptions = {
//  onLoad: 'check-sso',
//  checkLoginIframe: false,
//  pkceMethod: 'S256',
// }
//

// import Keycloak from "keycloak-js";
//
// // export const keycloak = new Keycloak({
// //   url: "http://localhost:8080",      // Keycloak base URL
// //   realm: "procon-realm",          // match your imported realm
// //   clientId: "cx-react-app",        // matches your JSON
// // });
//
// const keycloak = new Keycloak({
//  url: "https://auth.makotap.com",      // Keycloak base URL
//  realm: "procon-realm",          // match your imported realm
//  clientId: "mako-react-app",        // matches your JSON
// });
//
// export default keycloak;
